module.exports = __webpack_public_path__ + "img/Ticket.7de28d24.png";